import React from "react";

import HorizontalBarChart from "./horizontal-bar";
import VerticalBarChart from "./vertical-bar";
import { dFlex, dFlexC, flex1 } from "./styles";
import OnePanel from "./OnePanel";
import Text from "./Text";
import TeamLegend from "./TeamLegend";

const OnePanelChart = ({
  title,
  vertical = false,
  chartTitle,
  children,
  data,
  suffix = "",
  prefix = "",
  precision = 2,
  format = null,
  customChart = null,
  customColors = null,
  showCategoryLabels = false,
  instructorData = null,
  teams = null,
  yaxisFormatter = null,
}) => (
  <div style={dFlex}>
    <OnePanel title={title} style={flex1}>
      {children}
    </OnePanel>
    <div
      style={{
        ...flex1,
        ...dFlexC,
        maxWidth: "65%",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      {customChart !== null ? (
        customChart
      ) : vertical ? (
        <VerticalBarChart
          data={data}
          prefix={prefix}
          suffix={suffix}
          precision={precision}
          customColors={customColors}
          showCategoryLabels={showCategoryLabels}
          instructorData={instructorData}
          teams={teams}
        />
      ) : (
        <HorizontalBarChart
          data={data}
          prefix={prefix}
          suffix={suffix}
          precision={precision}
          format={format}
          customColors={customColors}
          showCategoryLabels={showCategoryLabels}
          instructorData={instructorData}
          teams={teams}
          yaxisFormatter={yaxisFormatter}
        />
      )}
      <Text marginTop="15px">{chartTitle || title}</Text>
      <TeamLegend teams={teams} customColors={customColors} />
    </div>
  </div>
);

export default OnePanelChart;



// WEBPACK FOOTER //
// ./src/components/analysis/OnePanelChart.js